import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from '@devopsafs/react-ui-components';

import { ReactComponent as SearchIcon } from 'src/assets/icons/search.svg';

import filterStore from 'src/stores/filter-store';

import { AppRoute } from 'src/constants';
import { useLocalization } from 'src/contexts/localization-context';
import { getFiltersSearchParamsString } from 'src/utils';
import type { FindAnotherLotButtonProps } from './find-another-lot-button.props';

const FindAnotherLotButton = observer(({ className }: FindAnotherLotButtonProps) => {
  const { getLocalization } = useLocalization();
  return (
    <Button
      className={className}
      icon={<SearchIcon />}
      iconPosition="center"
      href={`${AppRoute.MAP_VIEW_PAGE}?${getFiltersSearchParamsString(filterStore)}`}
      label={getLocalization('Find Another Lot')}
      tag="link"
      target="_blank"
      theme="outlined"
    />
  );
});

export default FindAnotherLotButton;
